/* global axios */
import CacheEnabledApiClient from './CacheEnabledApiClient';

class Inboxes extends CacheEnabledApiClient {
  constructor() {
    super('inboxes', { accountScoped: true });
  }

  // eslint-disable-next-line class-methods-use-this
  get cacheModelName() {
    return 'inbox';
  }

  getCampaigns(inboxId) {
    return axios.get(`${this.url}/${inboxId}/campaigns`);
  }

  deleteInboxAvatar(inboxId) {
    return axios.delete(`${this.url}/${inboxId}/avatar`);
  }

  getAgentBot(inboxId) {
    return axios.get(`${this.url}/${inboxId}/agent_bot`);
  }

  setAgentBot(inboxId, botId) {
    return axios.post(`${this.url}/${inboxId}/set_agent_bot`, {
      agent_bot: botId,
    });
  }

  syncTemplates(inboxId) {
    return axios.post(`${this.url}/${inboxId}/sync_templates`);
  }

  createCSATTemplate(inboxId, template) {
    return axios.post(`${this.url}/${inboxId}/csat_template`, {
      template,
    });
  }

  getCSATTemplateStatus(inboxId) {
    return axios.get(`${this.url}/${inboxId}/csat_template`);
  }

  // GK-HUB: WhatsApp Template Management API methods
  listTemplates(inboxId, filters = {}) {
    const params = new URLSearchParams(filters).toString();
    const query = params ? `?${params}` : '';
    return axios.get(`${this.url}/${inboxId}/templates${query}`);
  }

  createTemplate(inboxId, template) {
    return axios.post(`${this.url}/${inboxId}/templates`, { template });
  }

  updateTemplate(inboxId, templateId, components) {
    return axios.patch(`${this.url}/${inboxId}/templates/${templateId}`, {
      components,
    });
  }

  deleteTemplate(inboxId, templateName, templateId) {
    const queryParams = { name: templateName };
    if (templateId) queryParams.hsm_id = templateId;
    return axios.delete(`${this.url}/${inboxId}/templates/${templateId}`, {
      params: queryParams,
    });
  }

  uploadTemplateMedia(inboxId, formData) {
    return axios.post(
      `${this.url}/${inboxId}/templates/upload_media`,
      formData,
      { headers: { 'Content-Type': 'multipart/form-data' } }
    );
  }
  // GK-HUB: end template management API
}

export default new Inboxes();
